import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import {PwaModeService} from './pwa-mode.service';
import {UserService} from './user.service';
import {AdminService} from './admin.service';
import {GroupContext} from '../models/group-context.model';
import {isPwaHead} from './pwa-route-policy';

const GROUP_UNAVAILABLE = 'Primary managed department is unavailable';

@Injectable()
export class PwaLandingService {
  constructor(private mode: PwaModeService, private users: UserService, private admin: AdminService) {}

  get isHeadLanding(): boolean { return this.mode.isEnabled && isPwaHead(this.users.getLocal()); }

  primaryDepartment(): Observable<string> {
    if (!this.isHeadLanding) { return Observable.throw(new Error(GROUP_UNAVAILABLE)); }
    return this.primaryContext().mergeMap(context => this.acceptManaged(context));
  }

  ownDepartment(): Observable<string> {
    return this.primaryContext().map(context => context.groupId);
  }

  private primaryContext(): Observable<GroupContext> {
    const user = this.users.getLocal();
    if (!user || !user.mainGroup) { return Observable.throw(new Error(GROUP_UNAVAILABLE)); }
    return this.departmentContext(user.mainGroup).mergeMap(context => {
      const parent = context.parentDepartment;
      return parent && parent.id ? this.departmentContext(parent.id) : Observable.of(context);
    });
  }

  private departmentContext(id: string): Observable<GroupContext> {
    return this.admin.getGroupContext(id).mergeMap(response => {
      if (!response.body || response.body.groupId !== id) { return Observable.throw(new Error(GROUP_UNAVAILABLE)); }
      return Observable.of(response.body);
    });
  }

  private acceptManaged(context: GroupContext): Observable<string> {
    return context.canManageMembership || context.canManageGroupSettings
      ? Observable.of(context.groupId) : Observable.throw(new Error(GROUP_UNAVAILABLE));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-landing.service.ts